import React, { useEffect, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import CollapseCard from "../Components/CollapseCard";
import Modal from "../Components/Modal";
import WagonForm from "../Components/WagonForm";
import WagonList from "../Components/WagonList";
import { useToast } from "../Components/toast/ToastProvider";

import {
  getAllWagons,
  saveWagon,
  updateWagon,
  deleteWagon,
} from "../Service/WagonService";

const Wagon = () => {
  const [wagonData, setWagonData] = useState([]);
  const [wagonForm, setWagonForm] = useState({
    date: "",
    station: "",
    vehicle_count: "",
    advance: "",
  });
  const [showModal, setShowModal] = useState(false);

  const toast = useToast();

  useEffect(() => {
    fetchWagons();
  }, []);

  const fetchWagons = async () => {
    try {
      const res = await getAllWagons();
      setWagonData(res.data);
    } catch (err) {
      toast("Failed to fetch wagon", "ERROR");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !wagonForm.date ||
      !wagonForm.station ||
      !wagonForm.vehicle_count ||
      !wagonForm.advance
    ) {
      toast("Please fill all fields", "ERROR");
      return;
    }

    try {
      if (wagonForm.id) {
        await updateWagon(wagonForm);
        toast("Wagon updated successfully");
      } else {
        await saveWagon(wagonForm);
        toast("Wagon added successfully");
      }

      fetchWagons();
      handleCancel();
    } catch (err) {
      toast("Failed to save wagon", "ERROR");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setWagonForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEdit = (item) => {
    setWagonForm(item);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;

    try {
      await deleteWagon(id);
      toast("Deleted successfully");
      fetchWagons();
    } catch {
      toast("Delete failed", "ERROR");
    }
  };

  const handleCancel = () => {
    setWagonForm({
      date: "",
      station: "",
      vehicle_count: "",
      advance: "",
    });
    setShowModal(false);
  };

  return (
    <Main>
      <PageContainer
        titlePage="Wagon"
        buttonText="ADD"
        onButtonClick={() => setShowModal(true)}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={handleCancel}
          headerText={wagonForm.id ? "Edit Wagon" : "Add Wagon"}
        >
          <WagonForm
            wagonForm={wagonForm}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
          />
        </Modal>

        <CollapseCard title="Wagon List">
          <WagonList
            wagonData={wagonData}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default Wagon;
